<template>
  <loading v-if="listLoading"></loading>
  <div class="team" v-else>
    <div class="team-list">
      <div class="team-list-box" v-for="(item, index) in list" :key="index">
        <div class="team-list-box-msg-title">
          <div class="team-list-box-left-title">{{ item.name }}战队</div>
          <div class="team-list-box-right-title">战队队长</div>
        </div>

        <div class="team-list-box-msg" v-if="item.my_team">
          <div class="team-list-box-left">
            <!-- <div class="team-list-box-left-title">王者荣耀战队</div> -->
            <div class="team-list-box-left-game">
              <img class="imgs" :src="item.my_team.avatar" alt="" />
              <div class="team-list-box-left-game-right">
                <div>{{ item.my_team.name }}</div>
                <img
                  src="../../../assets/image/edit.png"
                  alt=""
                  v-if="item.my_team.isEdit"
                  @click="goEditTeam('修改战队', item.my_team.id, index)"
                />
              </div>
            </div>
          </div>
          <div class="team-list-box-right">
            <!-- <div class="team-list-box-right-title">战队队长</div> -->
            <div class="team-list-box-left-captain">
              <!-- 队长 -->
              <div
                class="team-list-box-left-captain-box"
                v-for="(v, i) in item.my_team.team_member"
                :key="i"
                v-if="v.type == 1"
              >
                <img :src="v.avatar" alt="" />
                <div class="team-list-box-left-captain-box-right">
                  <span>{{ v.name }}</span>
                  <div
                    class="team-list-box-left-captain-box-right-operation"
                    v-if="v.isEdit"
                  >
                    <div
                      class="team-list-box-left-captain-box-right-operation-box"
                      @click="goEditTeam('修改战队成员', v.id, index, i)"
                    >
                      <img src="../../../assets/image/team-edit.png" alt="" />
                      <span>修改</span>
                    </div>
                    <div
                      class="team-list-box-left-captain-box-right-operation-box"
                      @click="teamDissolution(item.my_team.id)"
                    >
                      <img src="../../../assets/image/team-del.png" alt="" />
                      <span>解散战队</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 邀请好友 -->
              <!-- <el-popover
                placement="bottom"
                width="200"
                trigger="click"
                v-model="visible"
              >
                <div class="popover-content" v-loading="loadingPopover">
                  <img :src="code" alt="" />
                  <p>扫一扫，进入小程序</p>
                </div>
                <div slot="reference" class="popover-box">
                  <img src="../../../assets/image/addTeam.png" alt="" />
                  <div class="popover-box-right">
                    <div class="popover-box-right-title">
                      <div>邀请好友</div>
                      <div>加入战队</div>
                    </div>
                    <img src="../../../assets/image/go.png" alt="" />
                  </div>
                </div>
              </el-popover> -->
              <div
                class="team-list-box-left-captain-box2"
                @click="setWxMiniCode(item)"
              >
                <img src="../../../assets/image/addTeam.png" alt="" />
                <div class="team-list-box-left-captain-box-right2">
                  <div class="team-list-box-left-captain-box-right2-add">
                    <div>邀请好友</div>
                    <div>加入战队</div>
                  </div>
                  <img src="../../../assets/image/go.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="no-team" v-else>
          <img src="../../../assets/image/no-team.png" alt="" />
          <div class="no-team-box">
            <span class="span">当前暂无战队，可以点击下面按钮创建战队</span>
            <el-button
              class="button"
              type="primary"
              icon="el-icon-plus"
              @click="goEditTeam('创建战队', item.id, index)"
              >创建战队</el-button
            >
          </div>
        </div>
        <!-- 战队成员 -->
        <div class="team-list-box-members">
          <div class="team-list-box-members-title">战队成员</div>
          <div class="team-list-box-members-list" v-if="item.my_team">
            <div
              class="team-list-box-members-list-box"
              v-if="item.my_team.team_member.length > 1"
            >
              <div
                class="team-list-box-left-captain-box"
                v-for="(items, indexs) in item.my_team.team_member"
                :key="indexs"
              >
                <img :src="items.avatar" alt="" />
                <div class="team-list-box-left-captain-box-right">
                  <span>{{ items.name }}</span>
                  <div
                    class="team-list-box-left-captain-box-right-operation"
                    v-if="items.isEdit"
                  >
                    <div
                      class="team-list-box-left-captain-box-right-operation-box"
                      @click="
                        goEditTeam('修改战队成员', items.id, index, indexs)
                      "
                    >
                      <img src="../../../assets/image/team-edit.png" alt="" />
                      <span>修改</span>
                    </div>
                    <div
                      class="team-list-box-left-captain-box-right-operation-box"
                      @click="teamMemberDel(items.id)"
                    >
                      <img src="../../../assets/image/team-del.png" alt="" />
                      <span>退出</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="no_members" v-else>暂无队员</div>
          </div>
          <div class="no_members" v-else>请先创建战队</div>
        </div>
      </div>
    </div>
    <!-- 余额 -->
    <el-dialog
      title="修改头像"
      custom-class="dialog"
      :visible.sync="editTeam"
      center
      width="22%"
    >
      <div class="balance">
        <UploadOne v-model="form.avatar"></UploadOne>
        <div class="input">
          <div>修改昵称</div>
          <el-input
            v-model="form.name"
            placeholder="昵称仅限7个字"
            maxlength="7"
          ></el-input>
          <span>请输入新昵称，仅限文字、字母、数字、下划线</span>
        </div>

        <div class="recharge-btn">
          <el-button type="primary" @click="handCreate">保存</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="邀请二维码"
      :visible.sync="dialogWxinvite"
      width="30%"
      @closed="closewxinvite"
    >
      <div class="wxLoginImg">
        <img :src="code" alt="" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";
import loading from "@/components/loading/loading.vue";
import { mapGetters } from "vuex";
export default {
  components: { UploadOne, loading },
  data() {
    return {
      editTeam: false,
      listLoading: true,
      dialogWxinvite: false,
      list: [],
      form: {
        match_type_id: 1,
        id: "",
        name: "",
        avatar: "",
      },
      type: "",
      visible: false,
      code: "",
      loadingPopover: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.setWxMiniCode();
      } else {
        this.code = "";
      }
    },
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  methods: {
    closewxinvite() {
      this.code = "";
      this.dialogWxinvite = false;
    },
    handCreate() {
      if (this.type == "创建战队") {
        this.createTeam();
      } else if (this.type == "修改战队") {
        this.teamStore();
      } else if (this.type == "修改战队成员") {
        this.teamMemberStore();
      }
    },
    goEditTeam(type, id, index, minIndex) {
      this.editTeam = true;
      this.type = type;
      this.form = {
        match_type_id: "",
        id: "",
        name: "",
        avatar: "",
      };
      if (type == "创建战队") {
        this.form.match_type_id = id;
      } else if (type == "修改战队") {
        this.form.id = id;
        this.form.avatar = this.list[index].my_team.avatar;
        this.form.name = this.list[index].my_team.name;
      } else if (type == "修改战队成员") {
        this.form.id = id;
        this.form.avatar =
          this.list[index].my_team.team_member[minIndex].avatar;
        this.form.name = this.list[index].my_team.team_member[minIndex].name;
      }
    },
    // 邀请加入战队
    setWxMiniCode(item) {
      let team = {
        id: item.my_team.id,
      };
      let url =
        "/pages/my_team/my_team?team=" +
        JSON.stringify(team) +
        "&active=" +
        item.my_team.match_type_id;
      this.loadingPopover = true;
      request({
        url: "api/common/qrcode/wxMiniCode",
        method: "post",
        params: { url: url },
      }).then((response) => {
        this.code = response.data;
        this.loadingPopover = false;
        this.dialogWxinvite = true;
      });
    },
    // 创建战队
    createTeam() {
      if (!this.form.name) {
        this.$message.error("战队名称不能为空！");
        return;
      }
      if (!this.form.avatar) {
        this.$message.error("战队头像不能为空！");
        return;
      }
      request({
        url: "/api/frontend/user/createTeam",
        method: "post",
        params: this.form,
      }).then((response) => {
        this.editTeam = false;
        this.form = {
          match_type_id: "",
          id: "",
          name: "",
          avatar: "",
        };
        this.$message.success("创建战队成功");
        this.getList();
      });
    },
    // 修改战队信息
    teamStore() {
      if (!this.form.name) {
        this.$message.error("战队名称不能为空！");
        return;
      }
      if (!this.form.avatar) {
        this.$message.error("战队头像不能为空！");
        return;
      }
      request({
        url: "/api/userend/user/teamStore",
        method: "post",
        params: this.form,
      }).then((response) => {
        this.editTeam = false;
        this.form = {
          match_type_id: "",
          id: "",
          name: "",
          avatar: "",
        };
        this.$message.success("修改成功");
        this.getList();
      });
    },
    // 修改战队成员信息
    teamMemberStore() {
      if (!this.form.name) {
        this.$message.error("名称不能为空！");
        return;
      }
      if (!this.form.avatar) {
        this.$message.error("头像不能为空！");
        return;
      }
      request({
        url: "/api/userend/user/teamMemberStore",
        method: "post",
        params: this.form,
      }).then((response) => {
        this.editTeam = false;
        this.form = {
          match_type_id: "",
          id: "",
          name: "",
          avatar: "",
        };
        this.$message.success("修改成功");
        this.getList();
      });
    },
    // 删除成员退出战队
    teamMemberDel(id) {
      this.$confirm("此操作将解散战队, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //点击确定的操作(调用接口)
          request({
            url: "/api/userend/user/teamMemberDel",
            method: "post",
            params: { team_member_id: id },
          }).then((response) => {
            this.$message.success("操作成功");
            this.getList();
          });
        })
        .catch(() => {
          //几点取消的提示
        });
    },
    // 解散战队
    teamDissolution(id) {
      this.$confirm("此操作将解散战队, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //点击确定的操作(调用接口)
          request({
            url: "/api/userend/user/teamDissolution",
            method: "post",
            params: { team_id: id },
          }).then((response) => {
            this.$message.success("解散战队成功");
            this.getList();
          });
        })
        .catch(() => {
          //几点取消的提示
        });
    },
    // 比赛列表
    getList() {
      this.listLoading = true;
      request({
        url: "/api/userend/user/team",
        method: "get",
        params: {},
      }).then((response) => {
        // this.list=response.data
        if (response.data) {
          response.data.forEach((item) => {
            if (item.my_team) {
              item.my_team.isEdit = false;
              let index = item.my_team.team_member.findIndex((list) => {
                list.isEdit = false;
                return list.user_id == this.getUserInfo.id;
              });
              if (item.my_team.team_member[index].type == 1) {
                item.my_team.isEdit = true;
              }
              if (index >= 0) {
                item.my_team.team_member[index].isEdit = true;
              } else [(item.my_team.team_member[index].isEdit = false)];
            }
          });
        }
        console.log(response.data, "response.data");
        this.list = response.data;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.popover-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
  p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #506176;
  }
}
.popover-box {
  cursor: pointer;
  width: 270px;
  background: #f5fafe;
  border-radius: 8px;
  padding: 20px 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    width: 62px;
    height: 62px;
  }
  .popover-box-right {
    margin-left: 24px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .popover-box-right-title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      div {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3d7eff;
        &:nth-child(2) {
          margin-top: 10px;
        }
      }
    }
    img {
      margin-left: 21px;
      width: 20px;
      height: 20px;
    }
  }
}
.height7 {
  height: 100vh;
}
.team {
  padding: 22px 30px;
  background: #ffffff;
  border-radius: 8px;
  .dialog {
    border-radius: 20px;
  }
  .el-dialog__title {
    line-height: 1.5rem;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1e2134;
  }
  .balance {
    width: 100%;
    .balance-num {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 120px;
      margin: 0 auto;
      position: relative;
      margin-bottom: 30px;
      img {
        &:nth-child(1) {
          width: 120px;
          height: 120px;
          border-radius: 50%;
        }
        &:nth-child(2) {
          width: 37px;
          height: 37px;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
    }
    .input {
      width: 336px;
      margin: 0 auto;
      .el-input__inner {
        width: 336px;
        height: 57px;
        background: #f9fafd;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin: 0 auto;
        border: none;
        margin-bottom: 15px;
      }
      div {
        text-align: center;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1e2134;
        margin-bottom: 15px;
      }
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #858585;
      }
    }

    .recharge-btn {
      width: 336px;
      height: 50px;
      margin: 0 auto;
      margin-top: 30px;
      .el-button {
        width: 336px;
        height: 50px;
        margin: 0 auto;
        background: #3d7eff;
        border-radius: 6px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .team-list {
    .team-list-box {
      border-bottom: 1px solid #f9fafd;
      padding-bottom: 30px;
      margin-bottom: 30px;
      .team-list-box-msg-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .team-list-box-left-title {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1e2134;
        }
        .team-list-box-right-title {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1e2134;
          margin-right: 43.5%;
        }
      }
      .no-team {
        margin-top: 18px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        img {
          width: 112px;
          height: 99px;
        }
        .no-team-box {
          margin-left: 33px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .span {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #506176;
          }
          .button {
            width: 128px;
            height: 42px;
            color: #ffffff;
          }
        }
      }
      .team-list-box-msg {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .team-list-box-left {
          width: 49%;
          .team-list-box-left-title {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1e2134;
          }
          .team-list-box-left-game {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-top: 20px;
            .imgs {
              width: 100px;
              height: 100px;
              border-radius: 50%;
            }
            .team-list-box-left-game-right {
              cursor: pointer;
              width: 68%;
              margin-left: 20px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              border-radius: 8px;
              border: 1px solid #f9fafd;
              padding: 15px 40px;
              div {
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #1e2134;
              }
              img {
                width: 30px;
                height: 30px;
              }
            }
          }
        }
        .team-list-box-right {
          width: 48%;
          .team-list-box-right-title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1e2134;
          }
          .team-list-box-left-captain {
            margin-top: 25px;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .team-list-box-left-captain-box {
              padding: 15px 20px;
              width: 42%;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              background: #f9fafd;
              border-radius: 8px;
              img {
                width: 62px;
                height: 62px;
                border-radius: 50%;
              }
              .team-list-box-left-captain-box-right {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                margin-left: 12px;
                span {
                  font-size: 20px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #1e2134;
                }
                .team-list-box-left-captain-box-right-operation {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  width: 100%;
                  .team-list-box-left-captain-box-right-operation-box {
                    white-space: nowrap;
                    cursor: pointer;
                    width: 49%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    margin-right: 21px;
                    img {
                      width: 20px;
                      height: 20px;
                    }
                    span {
                      font-size: 16px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #506176;
                      margin-left: 5px;
                    }
                  }
                }
              }
            }
            .team-list-box-left-captain-box2 {
              cursor: pointer;
              padding: 15px 20px;
              width: 42%;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              background: #f9fafd;
              border-radius: 8px;
              img {
                width: 62px;
                height: 62px;
                border-radius: 50%;
              }
              .team-list-box-left-captain-box-right2 {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-items: center;
                margin-left: 12px;
                .team-list-box-left-captain-box-right2-add {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  div {
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3d7eff;
                  }
                }
                img {
                  width: 20px;
                  height: 20px;
                }
              }
            }
          }
        }
      }
      .team-list-box-members {
        margin-top: 20px;
        // height: 132px;
        .team-list-box-members-title {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1e2134;
        }
        .no_members {
          height: 112px;
          line-height: 112px;
          text-align: center;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #dddddd;
        }
        .team-list-box-members-list {
          // margin-top: 20px;
          // width: 100%;
          // display: flex;
          // flex-direction: row;
          // justify-content: space-between;
          .no_members {
            height: 112px;
            line-height: 112px;
            text-align: center;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #dddddd;
          }
          .team-list-box-members-list-box {
            margin-top: 20px;
            width: 100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            .team-list-box-left-captain-box {
              padding: 15px 20px;
              width: 21%;
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              background: #f9fafd;
              border-radius: 8px;
              margin-bottom: 10px;
              img {
                width: 62px;
                height: 62px;
                border-radius: 50%;
              }
              .team-list-box-left-captain-box-right {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                margin-left: 12px;
                span {
                  font-size: 20px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #1e2134;
                }
                .team-list-box-left-captain-box-right-operation {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  width: 100%;
                  .team-list-box-left-captain-box-right-operation-box {
                    cursor: pointer;
                    width: 49%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    margin-right: 21px;
                    img {
                      width: 20px;
                      height: 20px;
                    }
                    span {
                      font-size: 16px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #506176;
                      margin-left: 5px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>